import {Globals} from './globals';
/**
 * Created by Fayaz on 2/14/2018.
 */
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {Router, ActivatedRoute} from '@angular/router';
import {RestangularModule, Restangular} from 'ngx-restangular';
import {AuthService} from './auth.service';
import { API_URL } from '../config';

@Injectable()
export class AuthenticationService {
  private accessRights: any = {};

  constructor(private http: HttpClient,
              private route: ActivatedRoute,
              private router: Router,
              private global: Globals,
              private restangular: Restangular,
              private authService: AuthService
  ) {
    
  }

  headers: any = new HttpHeaders()
    .set('Content-Type', 'application/x-www-form-urlencoded');

  login(username: string, password: string) {
    var params: any = {
      'grant_type': 'password',
      'client_id': '3',
      'client_secret': 'N1TZtXOcP0m2IJReOPsywi0xQBxiWKZKxGlRDqU1',
      'username': username, //'admin@mail.com',
      'password': password, //'password1',
      // 'username': "admin@pbs-int.net",
      // 'password': "welcome1",
      'scope': '*',
    };
    //{ username: username, password: password }



    
    return this.http.post<any>( API_URL+'/oauth/token', params)
      .map(user => {
        // login successful if there's a jwt token in the response
        //if (user && user.token_type) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        //   localStorage.setItem('currentUser', JSON.stringify(user));
        localStorage.setItem('access_token', user['access_token']);
        localStorage.setItem('refresh_token', user['refresh_token']);
        //sessionStorage.setItem('access_token',  user['access_token']);
        //}
        this.authService.isLoggedIn = true;
        return user;
      });
  }

  loginWithToken(username: string, token: string) {

    var params: any = {
      'username': username,
      'token': token,
    };

    return this.http.post<any>( API_URL+'api/v1/oauth/login_with_token', params)
      .map(user => {
        localStorage.setItem('access_token', user['accessToken']);
        localStorage.setItem('refresh_token', null);
        //sessionStorage.setItem('access_token',  user['access_token']);
        //}
        this.authService.isLoggedIn = true;
        return user;
      });
  }

  isLogged() {
    return ((localStorage.getItem('access_token') || localStorage.getItem('refresh_token')) && this.authService.isLoggedIn);
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.clear();
    sessionStorage.clear();
    const currentUrl = this.router.url;
    if (!currentUrl.includes("pages/login")) {
      let currentRoute = currentUrl.split('?')[0];
      this.route.queryParams.subscribe(queryParams => {
        if (Object.keys(queryParams).length != 0) {
          this.global.returnQueryParams = queryParams;
        }
      });
      this.global.returnUrl = currentRoute;
    }
    this.authService.logout();
    setTimeout(() => {
      this.router.navigate(['pages/login']);
      const frame = document.getElementsByTagName('hds-iframe');
      if (frame.length) {
        frame[0].remove();
      }
    }, 0);

  }

  refreshToken() {
    if (localStorage.getItem('refresh_token')) {
      var params: any = {
        'grant_type': 'refresh_token',
        'client_id': '3',
        'client_secret': 'N1TZtXOcP0m2IJReOPsywi0xQBxiWKZKxGlRDqU1',
        'refresh_token': localStorage.getItem('refresh_token'),
        'scope': '',
      };
      return this.http.post<any>(API_URL+'/oauth/token', params)
        .map(user => {
          localStorage.setItem('access_token', user['access_token']);
          localStorage.setItem('refresh_token', user['refresh_token']);
          return user;
        });
    } else {
      this.router.navigate(['pages/login']);
    }
  }

  checkAuth() {
    return this.restangular.one('checkUser');
  }

  checkUserGroupAccessRights() {
    return this.restangular.one('checkUserGroupAccessRights');
  }

  setUserGroupAccessRights(accessRights) {
    this.accessRights = accessRights;
  }

  getUserGroupAccessRights(currentRoute) {
    return currentRoute.data.data;
  }

  getCurrentUserInfo() {
    return this.restangular.one('getCurrentUserInfo');
  }

  getTotalCountOfApproval() {
    return this.restangular.one('getTotalCountOfApproval');
  }

  loginwithToken() {
    return this.restangular.one('loginwithToken');

  }

  passwordreset() {
    return this.restangular.one('passwordreset');
  }

  forgotpassword() {
    return this.restangular.all('forgotpassword');
  }

  forgotpasswordReset() {
    return this.restangular.one('forgotpasswordReset');
  }

  getCommunicationLogPDF() {
    return this.restangular.one('getCommunicationLogPDF');
  }

  getUserMenu() {
    return this.restangular.one('getUserMenu');
  }

  checkLoggedEmployeeAzureUser() {
    return this.restangular.one('checkLoggedEmployeeAzureUser');
  }

  getTemplateAssignedRoute() {
    return this.restangular.one('getTemplateAssignedRoute');
  }







}






// WEBPACK FOOTER //
// /app/src/app/services/authentication.service.ts